import { gql } from "@apollo/client";

export const WANTED_ITEMS = gql`
  query FindManyWantedItem($where: FindManyWantedItemInput) {
    findManyWantedItem(where: $where) {
      id
      buyerUserId
      ndcNumber
      drugName
      manufacturer
      dosageForm
      strength
      notifiedAt
      createdAt
      deletedAt
    }
  }
`;

export const CREATE_WANTED_ITEM = gql`
  mutation CreateWantedItem($data: CreateWantedItemInput!) {
    createWantedItem(data: $data) {
      id
      buyerUserId
      ndcNumber
      drugName
      manufacturer
      dosageForm
      strength
      notifiedAt
      createdAt
      deletedAt
    }
  }
`;

export const DELETE_WANTED_ITEM = gql`
  mutation DeleteWantedItem($where: DeleteWantedItemInput!) {
    deleteWantedItem(where: $where) {
      id
      deletedAt
    }
  }
`;
